import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { canchaService } from "../../services/canchaService";
import PublicNavbar from "./PublicNavbar";
import EstablishmentsCarousel from "./EstablishmentsCarousel";

export default function PublicEstablishmentsList() {
  const [establecimientos, setEstablecimientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchEstablecimientos();
  }, []);

  const fetchEstablecimientos = async () => {
    setLoading(true);
    setError("");
    try {
      // Suponiendo que el endpoint es /api/establecimientos-publicos
      const response = await canchaService.getAllEstablecimientos();
  setEstablecimientos(response.data);
    } catch (err) {
      setError("Error al cargar los establecimientos");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-green-100">
      <div className="flex items-center justify-center mb-4">
        <svg className="animate-spin h-10 w-10 text-emerald-500" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
        </svg>
      </div>
      <div className="text-lg text-emerald-700 font-semibold">Buscando establecimientos disponibles…</div>
    </div>
  );
  if (error) return <div className="text-red-500">{error}</div>;

  return (
    <div className="bg-gradient-to-br from-blue-50 to-green-100 min-h-screen pt-20 pb-10 overflow-x-hidden w-full">
      <PublicNavbar />
      <EstablishmentsCarousel
        establecimientos={establecimientos}
        autoPlay
        interval={2000}
        fullBleed
      />
      <div className="max-w-7xl mx-auto mt-10">
        <h1 className="text-3xl md:text-4xl font-extrabold text-center text-green-700 mb-6 drop-shadow-lg">
          Encuentra tu cancha ideal
        </h1>

  {(establecimientos && establecimientos.length === 0) ? (
          <div className="text-center text-gray-500 text-lg">
            No hay establecimientos registrados.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {(establecimientos || []).map((est) => (
              <div
                key={est.id}
                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300 p-6 flex flex-col items-center relative"
              >
                {est.imagenes && est.imagenes.length > 0 ? (
                  <img
                    src={est.imagenes[0]}
                    alt="foto negocio"
                    className="h-40 w-full object-cover rounded-xl mb-4 shadow"
                  />
                ) : (
                  <div className="h-40 w-full bg-gray-200 rounded-xl mb-4 flex items-center justify-center text-gray-400">
                    Sin imagen
                  </div>
                )}
                <h3 className="text-2xl font-bold text-green-800 mb-2 text-center">
                  {est.nombre_negocio}
                </h3>
                <p className="text-gray-700 mb-1 text-center">
                  <span className="font-semibold">Dirección:</span>{" "}
                  {est.direccion}
                </p>
                <p className="text-gray-700 mb-1 text-center">
                  <span className="font-semibold">Teléfono:</span>{" "}
                  {est.telefono}
                </p>
                <p className="text-gray-700 mb-3 text-center">
                  <span className="font-semibold">Email:</span> {est.email}
                </p>
                <div className="absolute top-4 right-4 bg-green-600 text-white px-3 py-1 rounded-full text-xs font-bold shadow">
                  ¡Promocionado!
                </div>
                <button
                  className="mt-4 bg-gradient-to-r from-green-500 to-blue-500 text-white font-semibold px-6 py-2 rounded-full shadow hover:scale-105 transition-transform duration-200"
                  onClick={() => navigate(`/establecimientos/${est.id}`)}
                >
                  Ver más
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
